export const getCookie = (cname) => {
    let name = cname + "=";
    let ca = document.cookie.split(';');
    for (let i = 0; i < ca.length; i++) {
        let c = ca[i];
        while (c.charAt(0) == ' ') {
            c = c.substring(1);
        }
        if (c.indexOf(name) == 0) {
            return c.substring(name.length, c.length);
        }
    }
    return "";
}

export const getCookieInRender = (name) => {
    if (process.browser) {
        const value = `; ${document.cookie}`;
        const parts = value.split(`; ${name}=`);
        if (parts.length === 2) return parts.pop().split(';').shift();
    }
}

export const setCookie = (name, value, duration) => {
    let d = new Date();
    d.setTime(d.getTime() + (duration * 24 * 60 * 60 * 1000));
    let expires = "expires=" + d.toUTCString();
    document.cookie = name + "=" + value + ";" + expires + ";path=/";
}

export const getPaywallShock = () => {
    const cookie = document.cookie.replace(/(?:(?:^|.*;\s*)paywall-choque\s*\=\s*([^;]*).*$)|^.*$/, "$1");
    if (cookie != "undefined" || cookie != "" ) {
        return cookie;
    }
    else{
        return 0;
    }
}